var $ = require("jquery");

$(document).ready(function () {
    var intervalId = window.setInterval(function () {
        $('#wpcf7-submit').removeAttr('Disabled');
    }, 100);
});